import { render, staticRenderFns } from "./ReportCreditTabUsers.vue?vue&type=template&id=16cb2a4d"
import script from "./ReportCreditTabUsers.vue?vue&type=script&lang=js"
export * from "./ReportCreditTabUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports